import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationStaffCategoryUpdatePutBody,
  IConfigurationStaffCategoryUpdateResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationStaffCategoryUpdateAPI = () => {
  const [updatedStaffCategoryId, setUpdatedStaffCategoryId] = useState<string>("");
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (staffCategoryData: IConfigurationStaffCategoryUpdatePutBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!staffCategoryData) {
          return;
        }
        await axios
          .put(`${CONFIGURATION_APIS?.STAFF_CATEGORY_UPDATE?.baseURL}` , staffCategoryData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationStaffCategoryUpdateResponse>) => {
            if (res.data.status === true) {
              setUpdatedStaffCategoryId(res.data.data.staff_category_id);
              toast.success(`${staffCategoryData?.category_name} has been updated successfully`);
            } else {
              toast.error("Error while updating staff category.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Staff Category already exists");
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );
  return { updatedStaffCategoryId, execute };
};
